import axios from "axios"

const PAGINATION = 15

const POST_COMMENT_URL = '/api/comments'
const POST_URL = '/api/posts'
const POST_PREVIEW_URL = `${POST_URL}/previews`
const POST_CATEGORIES = `${POST_URL}/categories`
const LIKE_POST_URL = `/api/follow`

const getPosts = async ( config = {} ) => {
    let params = {
        per_page: PAGINATION,
        ...( config.params ?? {} )
    }

    let { data: { data = [], success = false, meta = null } } = await axios.get( POST_URL, { params } )

    return { data, success, meta }
}

const getPostsPreviews = async ( config = {} ) => {
    let params = {
        per_page: PAGINATION,
        ...( config.params ?? {} )
    }

    let { data: { success = false, meta = null, data = {} } } = await axios.get( POST_PREVIEW_URL, { params } )

    return { data, success, meta }
}

const getCategories = async ( config = {} ) => {
    let params = {
        per_page: PAGINATION,
        ...( config.params ?? {} )
    }

    let { data: { success = false, meta = null, data = {} } } = await axios.get( POST_CATEGORIES, { params } )

    return { data, success, meta }
}

const likeArticle = async ( config ) => {
    let { params } = config

    return await axios.post( LIKE_POST_URL, params )
}

const postComment = config => {
    const params = {
        commentable_type: 'post',
        reply_comment_id: null,
        ...config
    }
    return axios.post( POST_COMMENT_URL, params )
}

const getPostComments = (post, config) =>{
    const params = {
        ...config
    }
    return axios.get( `${POST_URL}/${post}/comments`, { params } )
}

export { getPosts, getPostsPreviews, likeArticle, getCategories, postComment, getPostComments }